import styled from 'styled-components'
import { MediaBreakPointUp } from '~/theme'

export const StyledOrderPreview = styled.div`
  align-items: flex-start;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  margin: 68px auto 12px auto;
  width: 435px;
  max-width: 435px;
  position: relative;
  border: 0.5px solid #e7e2ff;

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    width: calc(100% - 30px);
    box-sizing: border-box;
    margin: 20px auto 15px;
    max-width: auto;
  }
`

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  left: 0px;
  outline: none;
  position: absolute;
  top: 10px;
  transform: rotate(90deg);
`

export const Title = styled.div`
  box-shadow: inset 0px -1px 0px #eaecf6;
  color: #191c1e;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  padding: 14px 0;
  text-align: center;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 8px 20px 25px;
  width: 100%;

  .border-bottom {
    border-bottom: 0.5px dashed #8d93b5;
    margin-bottom: 15px;
  }

  .token-label {
    margin-left: 15px;
  }
`

export const TokenRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 8px 0;
  width: 100%;
`

export const TokenIcon = styled.img`
  border: 1px solid #eff0fa;
  border-radius: 50%;
  flex: 0 0 28px;
  height: 28px;
  margin-right: 13px;
  width: 28px;
`

export const TokenValue = styled.div`
  color: #9598ab;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const TokenAmount = styled.div`
  color: #191c1e;
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`

export const StyledExpiredRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 4px;
  padding-bottom: 5px;
  width: 100%;
  color: #2c2842;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledExpiredValue = styled.div`
  letter-spacing: 0.2px;
`
